import React, {useEffect} from 'react';
import {
  deleteManualCalculateRow, updateManualCalculateRow
} from "../../../../actions/sqftManualCalculationFunctions";
import {connect} from "react-redux";
import {MANUAL_CALCULATION_MEASURE, MANUAL_CALCULATION_ROW_TYPES} from "../../constants";
//import AllFeaturesChecker from "../navigation/SqftNavEdges";
import SqftEdgeRowDropdown from "./SqftEdgeRowDropdown";
import FeatureName from "../../../visComponents/featureName";
import {getEdgeFeatures} from "../../helpers/shapeHelper";
import sqftConfig from "../canvas/store/sqftConfig";
import {getEdgesPlaceholder} from "../../../../reducers/sqftManualCalculationReducer";

const SqftEdgeRow = (props) => {
  const {row, edgeRows, rowIndex, rowLetter, updateManualCalculateRow, deleteManualCalculateRow} = props;
  //const [, forceUpdate] = useReducer(x => x + 1, 0);

  const handleDeleteClick = () => {
    deleteManualCalculateRow(MANUAL_CALCULATION_ROW_TYPES.edgeRows, row.id)
  };
  const handleUpdateClick = (event, measure) => {
    event.preventDefault();

    updateManualCalculateRow(MANUAL_CALCULATION_ROW_TYPES.edgeRows, row, {[measure]: event.target.value});
  };
  const handleToggleShowTypeClick = () => {
    hideRowTypesList();
    updateManualCalculateRow(MANUAL_CALCULATION_ROW_TYPES.edgeRows, row, {isShowTypesList: !row.isShowTypesList});
  };

  const hideRowTypesList = () => {
    {
      edgeRows.map((row) => {
        updateManualCalculateRow(MANUAL_CALCULATION_ROW_TYPES.edgeRows, row, {isShowTypesList: false});
      })
    }
  };

  const updateRowSelectedFeatureAfterIndex = (index, edgeFeature) => {
    edgeRows.map((row) => {
      if (row.id >= index) {
        updateManualCalculateRow(
          MANUAL_CALCULATION_ROW_TYPES.edgeRows,
          row,
          {[MANUAL_CALCULATION_MEASURE.selectedFeature]: edgeFeature}
        );
      }
    })
  };
  const navItems = getEdgeFeatures();
  const placeholder = getEdgesPlaceholder();

  // set default edge selectedFeature to first edge in navItems (navItems[0].part)
  // todo update in a single redux call
  useEffect(() => {
    if (navItems.length > 0 && !row.selectedFeature) {
      updateManualCalculateRow(
        MANUAL_CALCULATION_ROW_TYPES.edgeRows,
        row,
        {[MANUAL_CALCULATION_MEASURE.selectedFeature]: navItems[0].part}
      );
    }
  },[row, updateManualCalculateRow, navItems])

  return (
    <div className="row body-row drop-down-container" data-index={rowIndex}>
      <div className="col-xs-2">
        {rowLetter}
      </div>
      <div className="col-xs-4">
        <input type="number" className="input-length" placeholder={sqftConfig.getMeasureUnitPostfix()}
               value={row.length}
               onChange={(e) => {
                 handleUpdateClick(e, MANUAL_CALCULATION_MEASURE.length)
               }}/>
      </div>
      <div className="col-xs-2"/>
      <div className="col-xs-4">
        <input type="number" data-group="edge-input-height" className="input-height" placeholder={placeholder}
               value={row.height}
               onChange={(e) => {
                 handleUpdateClick(e, MANUAL_CALCULATION_MEASURE.height)
               }}/>
      </div>
      <div className="col-xs-2"/>
      <div className="col-xs-4 row-type">
        <span className="drop-down-btn no-user-select" onClick={handleToggleShowTypeClick}>
          {
            navItems.length > 0
              ? row.selectedFeature
                ? <FeatureName feature={row.selectedFeature}/>
                : <FeatureName feature={navItems[0].part}/>
              : ""
          }
        </span>
        <span className={"drop-down-list " + (row.isShowTypesList ? "" : "hide")} data-for={"edge-type-" + {rowIndex}}>
          <ul className="drop-down-list-item-container" data-index="{row-index}">
            {
              navItems.map((navItem) =>
                <SqftEdgeRowDropdown
                  row={row}
                  updateRowSelectedFeatureAfterIndex={updateRowSelectedFeatureAfterIndex}
                  handleToggleShowTypeClick={handleToggleShowTypeClick}
                  edgeFeature={navItem.part}
                  key={navItem.part.dbFeature.id}
                />)
            }
            {/*{featureGroup && featureGroup.part && !featureGroup.part.allFeaturesReceived*/}
            {/*? <AllFeaturesChecker subPart={featureGroup} callBack={() => forceUpdate(1)} loaderOnly={true}/>*/}
            {/*: navItems.map(navItem => <SqftEdgeRowDropdown edgeFeature={navItem.part} key={navItem.part.dbFeature.id}/>)}*/}
          </ul>
        </span>
      </div>
      <div className="col-xs-2 circle" onClick={handleDeleteClick}>
        <span className="js-remove-row"/>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => ({
  edgeRows: store.sqftManualCalculationState.edgeRows,
});

const mapDispatchToProps = {
  deleteManualCalculateRow,
  updateManualCalculateRow
};

export default connect(mapStateToProps, mapDispatchToProps)(SqftEdgeRow);
